import * as React from 'react';
import { Checkbox, Label, Text } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

import { CheckboxAdapterProps } from './CheckboxAdapter.types';
import analytics from '../../../../analytics';

export class CheckboxAdapter extends React.Component<CheckboxAdapterProps, {}> {
  state = {
    checked: false
  };

  handleChange = (): void => {
    const { field, form, label, changeHandler } = this.props;

    this.setState({ checked: !this.state.checked }, () => {
      form.setFieldValue(field.name, this.state.checked, false);

      if (changeHandler) {
        changeHandler({ [field.name]: this.state.checked });
      }

      analytics.checkboxClick(field.name, label, this.state.checked);
    });
  };
  render(): JSX.Element {
    const { field, id, label } = this.props;
    return (
      <Box alignItems="center" direction="row" display="flex">
        <Checkbox
          data-id={id}
          name={field.name}
          onClick={this.handleChange}
          checked={this.state.checked}
        />
        <Label htmlFor={id}>
          <Box paddingX={2}>
            <Text size={'sm'}>{label}</Text>
          </Box>
        </Label>
      </Box>
    );
  }
}

export { CheckboxAdapter as default };
